import React from 'react';

const CountryFlag = ({ code, size = 'md', className = '' }) => {
  if (!code) return null;
  const c = code.toUpperCase();
  const sizes = {
    xs: 'w-4 h-3',
    sm: 'w-5 h-4',
    md: 'w-6 h-4',
    lg: 'w-8 h-6',
    xl: 'w-10 h-7',
    '2xl': 'w-14 h-10',
  };
  return (
    <img
      src={`https://flagcdn.com/w80/${c.toLowerCase()}.png`}
      alt={c}
      className={`inline-block rounded-sm object-cover ${sizes[size] || sizes.md} ${className}`}
      loading="lazy"
    />
  );
};

export default CountryFlag;
